module.exports = __webpack_public_path__ + "img/reader-outline.3ba92c99.svg";